import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();

    const anchorSpace = window.innerHeight * 0.1; // 5vw
    const lenis = new Lenis();

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // ページ内リンク対応
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', e => {
        const targetId = anchor.getAttribute('href');
        const target = document.querySelector(targetId);

        if (!target) return;

        e.preventDefault();

        lenis.scrollTo(target, {
          offset: -anchorSpace,       // 固定ヘッダーあるなら調整
          duration: 1.2,   // スクロール時間
          easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        });
      });
    });


  if (document.body.classList.contains('contact') ) {
    topValidation();
  }

  // 対象の要素を取得
  const navBtn = document.querySelector('.nav-btn');
  const header = document.querySelector('.header');

  // クリックイベントを設定
  navBtn.addEventListener('click', () => {
    // .is-open クラスを付け外し（toggle）する
    header.classList.toggle('is-open');
    navBtn.classList.toggle('is-open');
  });

  const MVswiper = new Swiper('.mv-swiper', {
    loop: true,
    effect: 'fade', // フェード切り替えを指定
    fadeEffect: {
        crossFade: true // 重なりを防ぎ、綺麗に透過させる
    },
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    speed: 2000, // 切り替えスピード
});

  const blogSwiper = new Swiper('.index-blog-content', {
    loop: true,              // ループ有効化
    autoplay: {
      delay: 3000,           // 自動再生の間隔
    },

    slidesPerView: 1.2, // 表示するスライド数
    spaceBetween: 15,
    centeredSlides : true,

    breakpoints: {

      767: {
        slidesPerView: 2, // 表示するスライド数
        spaceBetween: 20,
      },

      1024: {
        slidesPerView: 2.8, // 表示するスライド数
        spaceBetween: 35,
        centeredSlides : false,
      }
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const updateMargin = () => {
    const target = document.querySelector('.header');
    const follower = document.querySelector('.side-bar'); // サイドバーを取得済み
    const followers = document.querySelectorAll('.mainimg, .mainimg-page');

    if (target) {
      const height = target.offsetHeight + 20;

      // --- 追加：サイドバーの top を更新 ---
      if (follower) {
        follower.style.top = `calc(5vh + ${height}px)`;
      }

      // 既存の mainimg 系の処理
      if (followers.length > 0) {
        followers.forEach(el => {
          el.style.marginTop = `${height}px`;

          if (el.classList.contains('mainimg-page')) {
            el.style.height = `calc(52vh - ${height}px)`;
          } else {
            el.style.height = `calc(92vh - ${height}px)`;
          }
        });
      }
    }
  };

  window.addEventListener('DOMContentLoaded', updateMargin);
  window.addEventListener('resize', updateMargin);



  // 全ての .js-scroll 要素を取得
  const scrollHints = document.querySelectorAll('.js-scroll');

  // 取得した要素に対して一つずつ処理を行う
  scrollHints.forEach((el) => {
    new ScrollHint(el, {
      i18n: {
        scrollable: "横スクロール",
      },
    });
  });




  let els = document.querySelectorAll('.js-fadeIn');

  function checkFadeIn() {
    let windowHeight = window.innerHeight;

    els.forEach(function(el) {
      if (el.classList.contains('is-scrollIn')) return;

      let rect = el.getBoundingClientRect();

      if (rect.top < windowHeight - 250) {
        el.classList.add('is-scrollIn');
      }
    });
  }

  window.addEventListener('scroll', checkFadeIn);
  window.addEventListener('load', checkFadeIn);


  // 子要素をディレイ付きで表示
  let parents = document.querySelectorAll('.js-fade-parent');

  function checkParentFade() {
    let windowHeight = window.innerHeight;

    parents.forEach(function(parent) {
      if (parent.classList.contains('is-shown')) return;

      let rect = parent.getBoundingClientRect();

      // 親が画面内に入ったら
      if (rect.top < windowHeight - 250) {
        parent.classList.add('is-shown');

        let children = parent.querySelectorAll('.js-fade-child');

        children.forEach(function(child, index) {
          setTimeout(function() {
            child.classList.add('is-scrollIn');
          }, index * 250);
        });
      }
    });
  }

  window.addEventListener('scroll', checkParentFade);
  window.addEventListener('load', checkParentFade);



});
